// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 12px;
  width: 24px;
  height: 100%;

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    right: 8px;
    top: 0px;
    display: flex;
    align-items: center;
  }
`;

export const DropDownButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 100%;
  }
`;

export const DropDownIcon = styled.div<{ showCollapsible: boolean; }>`
  font-size: 24px;
  width: 24px;
  height: 24px;
  display: inline-flex;

  color: ${({ theme }) => theme.colors.textPrimary};
  transition: transform 0.3s linear;
  ${({ showCollapsible }) => showCollapsible && `transform: rotate(-180deg);`}
`;
